module.exports = __webpack_public_path__ + "static/media/forensic.6e6e5876.jpg";